/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import Badge from './Badge';

/**
 * ParentalControlRating displays one or more parental control rating badges.
 * Each badge shows a rating label (e.g., "PG", "TV-14").
 * @param ratingNames - Array of parental control rating strings.
 */
const ParentalControlRating: FunctionComponent<{ ratingNames?: string[] }> = ({
    ratingNames = [],
}) => {
    const ratingBadges = ratingNames
        .filter((name) => name)
        .map((rating) => {
            return <Badge key={rating} text={rating} />;
        });
    return <React.Fragment>{ratingBadges.length > 0 ? ratingBadges : null}</React.Fragment>;
};

export default ParentalControlRating;
